<template>
  <div>
    <p class="title">Key Indicators</p>
    <div class="country-name">
      <img :src="countryImgUrl" alt="">
      <span>{{countryEn}}</span>
    </div>
    <el-row class="countryidx">
      <el-col
        :span='23'
        :offset='1'
        v-for='(item, index) in countryData '
        v-bind:key='index'
        class="idx"
        :title="item.label + ' ' + item.value + ' ' + item.unit_final + '(' + item.value_growth + item.value_growth_unit + ' YoY)'"
      >
        {{item.label}} {{item.value}} {{item.unit_final}} ({{item.value_growth}} {{item.value_growth_unit}} YoY)
      </el-col>
    </el-row>
    <div style="clear: both;"></div>
  </div>
</template>

<script>
import { getDataCommon } from "common/js/http/v3Api"
export default {
  props: {
    country: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      countryEn: '',
      countryImgUrl: '',
      countryData: []
    }
  },
  mounted() {
    this.getDataCommon()
    this.countryEn = this.country.countryEn;
    this.countryImgUrl = `/db/static/images/country/${this.country.countryEn}.png`
  },
  methods: {
    async getDataCommon() {
      const { data } = await getDataCommon({
        'countryCode': this.country.countryCode || '1',
        'fcode': 'F01_01',
        'pagesize': 1,
        't': new Date().getTime(),
        'other': this.other,
        'locales': 'en'
      }, { 'Content-Type': 'application/json;charset=utf8', 'API-TOKEN': '2CCA56D9D84849551E943895153D5AD5' })
      this.countryData = data.result.data
    }
  }
}
</script>

<style scoped  lang="scss">
.title {
  font-size: 16px;
  line-height: 2;
  color: rgb(64, 156, 249);
  margin: 4px 0 10px 0;
  padding-left: 10px;
  font-weight: 500;
  position: relative;
  border-bottom: 1px solid #dedede;
}
.title:after{
  content: '';
  width: 50px;
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 30px;
  display: block;
  background-color: rgb(64, 156, 249);
}
.country-name {
  margin: 20px;
  display: inline-block;
  vertical-align: sub;
  img {
    width: 106px;
    height: 70px;
  }
  span{
    font-size: 30px;
    color: #4c5e70;
    margin-left: 30px;
  }
}
.countryidx {
  padding: 0 1px;
  white-space: nowrap;
  overflow: hidden; /*内容超出后隐藏*/
  text-overflow: ellipsis; /* 超出内容显示为省略号*/
  height: calc(100% - 170px);
  overflow-y: auto;
}
.left,
.right {
  float: left;
  width: 50%;
}
.countryidx p {
  margin: 0;
}
.countryidx .idx {
  font-size: 14px;
  color: #636363;
  margin-bottom: 10px;
  overflow: hidden; /*内容超出后隐藏*/
  text-overflow: ellipsis; /* 超出内容显示为省略号*/
  white-space: nowrap;
}

.countryidx .left {
  padding-left: 10px;
}
</style>
